import { render, staticRenderFns } from "./collectSet.vue?vue&type=template&id=44e36e05&scoped=true&"
import script from "./collectSet.vue?vue&type=script&lang=js&"
export * from "./collectSet.vue?vue&type=script&lang=js&"
import style0 from "./collectSet.vue?vue&type=style&index=0&id=44e36e05&prod&scoped=true&lang=css&"
import style1 from "./collectSet.vue?vue&type=style&index=1&id=44e36e05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e36e05",
  null
  
)

export default component.exports